/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Icon, Link } from '@chakra-ui/react';
import forEach from 'lodash/forEach';
import { useCookies } from 'react-cookie';

/* Internal Imports */
/* Components */
import config from '@config';
import {
  isOpenInNewTab,
  refineUrlDomain,
} from '@eternal/Components/Utility/utils';

/* Services */

/**
 * Returns the Simple Button.
 *
 * @param style
 * @param {object} style - Style for button.
 * @param {string} bType - Button Type.
 * @param {string} region - Current User Country.
 * @param {string} language - Current User Language.
 * @param bType
 * @param region
 * @param lang
 * @param clickHandler
 * @param padding
 * @param textAlign
 * @param width
 * @param mb
 * @param mt
 * @param fontstyle
 * @param fontbold
 * @param extraDomains
 * @param disabled
 * @param pageName
 * @param height
 * @returns {ReactElement} SimpleButton component.
 */
export default function SimpleLink({
  style,
  bType,
  region,
  lang,
  clickHandler,
  height,
  padding,
  textAlign,
  width,
  mb,
  mt,
  fontstyle,
  fontbold,
  pageName,
  disabled = false,
  ...props
}) {
  const router = useRouter();
  const [currentUrl, setCurrentUrl] = useState('');
  const cookieParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ];
  const [cookies, setCookie] = useCookies(cookieParams);
  const [showArrow, setShowArrow] = useState(false);
  useEffect(() => {
    if (!router.isReady) return;
    setCurrentUrl(refineUrlDomain(style?.linkUrl, region, lang));
    // setTimeout(function () {
    forEach(cookieParams, function (cookie) {
      if (router.query[cookie]) {
        setCookie(cookie, router.query[cookie], {
          path: '/',
          maxAge: 3600 * 24, // Expires after 1year
          sameSite: true,
          domain: config.COOKIE_DOMAIN,
          secure: true,
        });
      }
    });
    // }, 0);
  }, [router.isReady, style?.linkUrl]);

  return (
    <>
      <Box
        boxSizing="borderBox"
        display={'flex'}
        color="#faf7f0"
        width={width || 'auto'}
        h={height || 'auto'}
        mb={mb}
        fontFamily="'FedraSansStd-medium', sans-serif"
        alignItems="center"
        justifyContent="center"
        mt={mt}
        ml={showArrow ? '10px' : props.leftM || '20px'}
        transition="all 0.4s linear"
      >
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Link
            display="flex"
            alignItems="center"
            justifyContent="center"
            pos="relative"
            className="eternal_link"
            fontSize={{ base: '12px', md: '14px', xl: '18px' }}
            color="#D04723"
            onMouseEnter={() => setShowArrow(true)}
            onMouseLeave={() => setShowArrow(false)}
            _hover={{ color: '#fff' }}
            onClick={clickHandler}
            target={isOpenInNewTab(currentUrl) ? '_blank' : ''}
            textTransform="uppercase"
            {...props}
          >
            {style?.buttonText}
            {showArrow && (
              <Icon
                width="25px"
                height="24px"
                viewBox="0 0 25px 24px"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.4141 12.0001L14.707 19.7072L13.2927 18.293L18.5856 13.0001L3.99985 13.0001V11.0001H18.5856L13.2927 5.70718L14.707 4.29297L22.4141 12.0001Z"
                  fill="white"
                />
              </Icon>
            )}
          </Link>
        </NextLink>
      </Box>
    </>
  );
}
